import { render } from "./PopUpModal.vue?vue&type=template&id=8b48df44&scoped=true"
import script from "./PopUpModal.vue?vue&type=script&lang=js"
export * from "./PopUpModal.vue?vue&type=script&lang=js"

import "./PopUpModal.vue?vue&type=style&index=0&id=8b48df44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b48df44"]])

export default __exports__